import { render } from "./ResidentRow.vue?vue&type=template&id=e79e446a&scoped=true"
import script from "./ResidentRow.vue?vue&type=script&lang=js"
export * from "./ResidentRow.vue?vue&type=script&lang=js"

import "./ResidentRow.vue?vue&type=style&index=0&id=e79e446a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e79e446a"]])

export default __exports__